/* eslint-disable */
import React, { useEffect, useCallback, Dispatch } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Button from '@material-ui/core/Button';
import ListAltIcon from '@material-ui/icons/ListAlt';
import IconButton from '@material-ui/core/IconButton';
import { readFile } from './../../helpers/commonmethod'
import GetAppIcon from '@material-ui/icons/GetApp';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import { useDropzone } from 'react-dropzone'
import { useDispatch, useSelector } from "react-redux";
import { importAnnexureParts } from "../../store/actions/annexureParts.actions";
import CancelIcon from "@material-ui/icons/CancelRounded"
import { getUniqueEnquirySessionId } from "../../store/actions/createUpdateEnquiry.actions";
import { getUniqueTimestamp } from "../../common/components/util";
import { get } from "lodash";
import { Typography } from "@material-ui/core";

function ImportDialog(props: any) {
  const [open, setOpen] = React.useState(false);
  const [uploadedFileName, setuploadedFileName] = React.useState('');
  const [uploadedFileNameError, setuploadedFileNameError] = React.useState(false);
  const [error, setError] = React.useState<string | string[] | null>(null);
  const [size, setSize] = React.useState<any>(0);
  const [file, setFile] = React.useState<any>("");
  const [openSnackbar, setOpenSnackBar] = React.useState<any>(false)
  const [openErrorSnackbar, setOpenErrorSnackbar] = React.useState(false)
  const [successMessage, setSuccessMessage] = React.useState("")
  const dispatch: Dispatch<any> = useDispatch();

  const { profileDetails }: any = useSelector((state: any) => state.profileDetails);
  const userName = get(profileDetails, 'data.data.basicInfo.displayName', "");
  const empId = get(profileDetails, 'data.data.basicInfo.empId', "");
  const { enquirySessionId }: any = useSelector(
    (state: any) => state.createUpdateEnquiry
  );

  // useEffect(() => {
  //   if (uploadedFileName && !uploadedFileNameError && error === '') {
  //     setOpen(false);
  //   }
  // }, [uploadedFileName, uploadedFileNameError, error])

  useEffect(() => {
    if (!open) {
      setuploadedFileName('');
      setuploadedFileNameError(false);
      setError('');
      setSize("")
      setFile("")
    }
  }, [open])

  useEffect(() => {
    dispatch(getUniqueEnquirySessionId(getUniqueTimestamp()));
  }, []);

  const convertToSize = (value: any) => {
    return Math.abs(Number(value)) >= 1.0e+9
      ? (Math.abs(Number(value)) / 1.0e+9).toFixed(2) + "BYTES"
      : Math.abs(Number(value)) >= 1.0e+6
        ? (Math.abs(Number(value)) / 1.0e+6).toFixed(2) + "MB"
        : Math.abs(Number(value)) >= 1.0e+3
          ? (Math.abs(Number(value))) + "KB"
          : Math.abs(Number(value));
  }

  const fileUploadChange = useCallback((data: any) => {
    if (data && data.length && data.length > 0 && data[0]) {
      if (data[0] && data[0].name.toLowerCase() && (data[0].name.toLowerCase().includes('.xlsx') || data[0].name.toLowerCase().includes('.xls'))) {
        readFile(data[0]);
        setError(null);
        setuploadedFileNameError(false);
      } else {
        setError('Please upload excel file');
        setuploadedFileNameError(true);
        setuploadedFileName(data[0] && data[0].name)
      }
    }
    let uploader: any = document.getElementById('storesfileupload');
    if (uploader) uploader.value = "";
  }, []) // eslint-disable-line

  const onDrop = useCallback((acceptedFiles: any) => {
    setSize(acceptedFiles[0].size)
    fileUploadChange(acceptedFiles)
    setFile(acceptedFiles && acceptedFiles[0])
    setuploadedFileName(acceptedFiles[0] && acceptedFiles[0].name)
  }, [fileUploadChange])

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  const handleSubmit = async () => {
    const formData: any = new FormData();
    const fileName = file && file.name.substring(file.name.lastIndexOf('/') + 1);
    const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
    let keyAttribute = `Brand=""&fieldname=${"importAnnexureParts"}&docExtension=${fileExtension}`
    const customHeaders = {
      "Accept": "application/json",
      "Lob-Id": "AUTO",
      "Channel-Id": "B2B",
      "Org-Id": "",
      "Accept-Language": "EN",
    };

    formData.append("entityName", "PRICING_TEAM");
    formData.append("keyAttribute", keyAttribute);
    formData.append("empId", empId);
    formData.append("webApplicationLoginId", sessionStorage.getItem('webApplicationLoginId'));
    formData.append("files", file);
    formData.append("label", 'xlsfile');
    formData.append("enquirySessionId", `b2bLSR${enquirySessionId}`);
    formData.append("selectedFileName", file.name);
    formData.append("updatedBy", userName);

    let data: any = await dispatch(importAnnexureParts(formData, customHeaders));
    if (data && data.error) {
      if (typeof data.error === 'string') {
        setError(data.error); // set as string
      } else if (Array.isArray(data?.error?.errors)) {
        setError(data.error.errors); // set as string[]
      } else {
        setError('An unknown error occurred.');
      }
      setuploadedFileNameError(true);
    } else {
      setOpenErrorSnackbar(true);
      setSuccessMessage(data?.message);
      setOpenSnackBar(true);
      setOpen(false);
    }
  }

  const handleopenCloseSnackbar = (open: any) => {
    setOpenSnackBar(open ? true : false);
  }

  const handleDownload = () => {
    const url = window.URL.createObjectURL(new Blob([file]));
    const link = document.createElement("a")
    link.href = url
    link.download = uploadedFileName
    document.body.appendChild(link)
    link.click()
  }

  return (
    <React.Fragment>
      <span className="cursor-pointer mr-2" onClick={(e) => {
        setuploadedFileName('');
        setuploadedFileNameError(false);
        e.preventDefault();
        setOpen(true);
        if (props.isOpened) props.isOpened()
      }}>
        <IconButton className="searchbarOptions" size="small">
          <ListAltIcon fontSize="inherit" />
          <span className="font-size-13 load-from-fav ml-1">Import Excel</span>
        </IconButton>
      </span>
      <Dialog fullWidth={true}
        maxWidth="sm"
        open={open ? true : false}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setOpen(false);
          }
        }}
        aria-labelledby="form-dialog-title">
        <DialogContent>
          <div className="d-flex justifyContentHorizontalSpacebetween ">
            <h4 className="page-title">Import Excel</h4>
            <a href="./sampleExcelAnnexureParts.xlsx" download="sampleExcelAnnexureParts.xlsx">
              <span className="cursor-pointer searchbarOptions">
                <IconButton className="mr-1" size="small">
                  <GetAppIcon fontSize="inherit" />
                  <span className="font-size-13 load-from-fav ml-1">Download Sample Excel</span>
                </IconButton>
              </span>
            </a>
          </div>
          <div className="d-flex mt-3 py-4 dropzoneImport" {...getRootProps()}>
            <div className="d-flex col-lg-6 col-md-6 col-sm-12 justify-content-center align-items-center dashed-right-border">
              <div className="dragHereIcon justify-content-center">
                <CloudUploadIcon fontSize="large" />
              </div>
              <div className="dragHereText ml-2">Drag your excel sheet here</div>
              <input className="d-none" type="file" hidden id="productsfileupload"{...getInputProps()} />

            </div>
            <div className="d-flex col-lg-6 col-md-6 col-sm-12 justify-content-center align-items-center">
              <Button
                className="font-size-11 addToEnquiryButton"
                size="small"
                // onClick={() => {
                //   fileUploadAction()
                // }}
                variant="contained" color="primary">Browse Excel</Button>
            </div>
          </div>
          {/* {uploadedFileNameError && <div className="d-flex font-weight-bold justify-content-center mt-2 text-danger">{uploadedFileName} - Invalid data format</div>} */}
          {uploadedFileName &&
            <div className="d-flex flex row pl-4">
              <div className="mt-2 row">
                {/* <div className="file uploadFile" onClick={handleDownload}>{uploadedFileName} ({convertToSize(size)}/10MB)</div> */}
                <div className="file uploadFile" onClick={handleDownload}>{uploadedFileName} </div>
                <div className="pl-2" onClick={() => {
                  setuploadedFileName('');
                  setuploadedFileNameError(false);
                  setError('');
                  setSize("")
                  setFile("")
                }}>
                  <IconButton style={{ color: '#1A9FE0' }} size="small">
                    <CancelIcon fontSize="inherit" />
                  </IconButton>
                </div>
              </div>
            </div>}
          {error && (
            <div className="d-flex flex-column font-weight-bold justify-content-center mt-2 text-danger text-center">
              {Array.isArray(error) ? (
                error.map((errMsg: string, index: number) => (
                  <Typography key={index} variant="body2" style={{ color: "#d32f2f", marginBottom: 12, borderRadius: '5px', padding: '5px', textAlign: 'left', background: "#f5dfdc" }}>
                    {errMsg}
                  </Typography>
                  // <div key={index}>{uploadedFileName} - {errMsg}</div>
                ))
              ) : (
                <div>{uploadedFileName} - {error}</div>
              )}
            </div>
          )}
          {/* {error && <div className="d-flex font-weight-bold justify-content-center mt-2 text-danger">{uploadedFileName} - {error}</div>} */}
          {/* {uploadedFileName && !uploadedFileNameError && error === '' && <div className="d-flex font-weight-bold justify-content-center mt-2 text-success">{uploadedFileName} imported succesfully!</div>} */}
        </DialogContent>
        <DialogActions className="mt-2 mb-4 justify-content-end">
          <Button variant="contained" className={`submit-button font-size-11 mr-3
                            ${file && uploadedFileNameError === false && !error ? "" : "lpo-button-disabled"}`}
            onClick={() => {
              handleSubmit();
              // setOpen(false);
            }}>
            Import
          </Button>
          <Button variant="contained" className="cancel-button font-size-11 mr-3" onClick={() => { setOpen(false) }}>
            Close
          </Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
}

export default ImportDialog;
